import CardHorizontal from './CardHorizontal';
export default CardHorizontal;
